<template>
  <div class="toolbar-group">
    <div class="toolbar-fixed">
      <md-toolbar md-elevation="0" class="md-transparent" :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}">
        <div class="md-toolbar-row">
          <div class="md-toolbar-section-start" style="align-items: stretch">
            <router-link class="subroute-link" v-for="route in siblingRoutes" :to="route.path" :key="route.path" style="position: relative">
							<span v-if="route.meta.hasNewActivity" class="new-activity-indicator">&centerdot;</span>
							<md-icon>{{ route.meta.icon }}</md-icon>
							<p>{{ route.name }}</p>
						</router-link>
          </div>
          <div class="md-toolbar-section-end">
            <md-button class="md-just-icon md-round md-simple md-toolbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </md-button>

            <!-- <div class="md-collapse">
              <md-list>
                <li class="md-list-item">
                  <a href="#/components/notifications" class="md-list-item-router md-list-item-container md-button-clean dropdown">
                    <div class="md-list-item-content">
                      <drop-down direction="down">
                        <md-button slot="title" class="md-button md-just-icon md-simple" data-toggle="dropdown">
                          <md-icon>notifications</md-icon> -->
                          <!-- <span class="notification">5</span> -->
                          <!-- <p class="hidden-lg hidden-md">Notifications</p>
                        </md-button>
                        <ul class="dropdown-menu dropdown-menu-right">
                          <li><a href="#">Nenhuma notificação</a></li>
                        </ul>
                      </drop-down>
                    </div>
                  </a>
                </li>
              </md-list>
            </div> -->
          </div>
        </div>
      </md-toolbar>
      <hr>
    </div>
    <div class="toolbar-spacing"></div>
  </div>

</template>

<script>
import userModel from '@/models/user.model'

export default{
  data () {
    return {
      siblingRoutes: [],
    };
  },
  mounted() {
    this.updateSiblingRoutes();
  },
  methods: {
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    minimizeSidebar () {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    },
    logout () {
      return userModel.logout()
        .then(() => this.$router.push('/login'))
        .catch(error => console.error(error));
    },
    updateSiblingRoutes() {
      const primaryRoutePath = this.$route.matched[1].path;
      const primaryRoutes = this.$router.options.routes[1].children;
      const siblingRoutes = primaryRoutes.find(route => primaryRoutePath.includes(route.path)).children;
			siblingRoutes?.forEach((route) => {
				// remove route parameters
				if (route.path.indexOf(":") > -1) {
					route.path = route.path.slice(0, route.path.indexOf(":") - 1);
				}
				// check for new activity
				if (route.meta.hasNewActivity === null && route.component?.options?.methods?.hasNewActivity) {
					route.component?.options?.methods?.hasNewActivity()
						.then(result => route.meta.hasNewActivity = result)
						.catch(error => console.error(error));
				}
			});
      this.siblingRoutes = siblingRoutes;
    },
  },
  watch: {
    '$route': function() {
      this.updateSiblingRoutes();
    },
  },
}
</script>


<style lang="scss">
  .subroute-link {
    // height: 70px;
    text-align: center;
    padding: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    margin-right: 10px;
    background-color: #eee;
  }

	.toolbar-group {
		@media print {
			display: none;
			margin: 0;
			padding: 0;
		}
	}

  .toolbar-fixed {
    position: fixed;
    width: calc(100% - 279px);
    // height: 111px;
    background-color: #f8f8f8;
    z-index: 2;

    hr {
      border-top: 1px solid #eee;
      border-bottom: none;
      border-left: none;
      border-right: none;
      margin: 20px 30px 0px;
    }
  }

  @media screen and (max-width: 991px) {
    .toolbar-fixed {
      width: 100%;
    }
  }

  .toolbar-spacing {
    height: 100px;
  }

	.new-activity-indicator {
		position: absolute;
		font-size: 65px;
		color: #f00;
		right: 5px;
		top: -5px;
	}
</style>
